module.exports = __webpack_public_path__ + "img/header.25b98e00.png";